import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import isEmpty from "validator/lib/isEmpty"
import isIP from "validator/lib/isIP"
import { v4 as uuidv4 } from "uuid"
import { useTranslation } from "react-i18next"

import { addNewPosTerminal, editPosTerminal } from "@redux"
import { Button, Modal, Select, TextField } from "components"
import classes from "./SmptPcPosModal.module.scss"
import clsx from "clsx"

const initialFormState = {
  name: "",
  ipAddress: "",
  comPort: "COM1",
  posPort: 1024
}

const initialFormErrorsState = {
  name: "",
  ipAddress: "",
  comPort: "",
  posPort: ""
}

const comPorts = []

for (let i = 1; i <= 100; i++) {
  comPorts.push({ label: `COM${i}`, value: `COM${i}` })
}

const SmptPcPosModal = (props) => {
  const {
    openPcPosModal,
    setOpenPcPosModal,
    posTerminalForEdit
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const accountId =
    useSelector(state => state.userAccountInfo._id)

  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormErrorsState)

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleExit = () => {
    setForm({ ...initialFormState })

    setFormErrors({ ...initialFormErrorsState })
  }

  const validate = () => {
    let result = true
    const errors = { ...initialFormErrorsState }

    if (isEmpty(form.name)) {
      result = false
      errors.name = t("نام_کارتخوان_اجباری_است")
    }

    if (isEmpty(form.ipAddress)) {
      result = false
      errors.ipAddress = t("Ip_کارتخوان_اجباری_است")
    } else if (!isIP(form.ipAddress)) {
      result = false
      errors.ipAddress = t("Ip_کارتخوان_صحیح_نیست")
    }

    if (isEmpty(String(form.posPort))) {
      result = false
      errors.posPort = t("پرت_کارتخوان_اجباری_است")
    }

    setFormErrors({ ...errors })

    return result
  }

  const handleSave = () => {
    if (!validate()) return

    const myNewPosTerminal = {
      _id: uuidv4(),
      name: form.name,
      value: form.name,
      terminalName: "pcPos",
      type: "pcPos",
      ipAddress: form.ipAddress,
      comPort: form.comPort,
      posPort: form.posPort
    }

    dispatch(
      addNewPosTerminal(myNewPosTerminal, accountId)
    )

    setOpenPcPosModal(false)
  }

  const handleEdit = () => {
    if (!validate()) return

    const myNewPosTerminal = {
      _id: posTerminalForEdit._id,
      name: form.name,
      value: form.name,
      terminalName: "pcPos",
      type: "pcPos",
      ipAddress: form.ipAddress,
      comPort: form.comPort,
      posPort: form.posPort
    }

    dispatch(
      editPosTerminal(myNewPosTerminal, accountId)
    )

    setOpenPcPosModal(false)
  }

  const handleEnter = () => {
    if (!posTerminalForEdit) return

    setForm({
      name: posTerminalForEdit.name,
      ipAddress: posTerminalForEdit.ipAddress,
      comPort: posTerminalForEdit.comPort || "COM1",
      posPort: posTerminalForEdit.posPort || 1024
    })
  }

  const editMode = !!posTerminalForEdit

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openPcPosModal}
      onHide={() => setOpenPcPosModal(false)}
      backdrop="static"
      onEnter={handleEnter}
      onExited={handleExit}
    >
      <div className={classes["container"]}>
        <TextField
          label={t("نام_کارتخوان")}
          value={form.name}
          error={formErrors.name}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "name")}
        />

        <TextField
          label={t("IP_کارتخوان")}
          value={form.ipAddress}
          error={formErrors.ipAddress}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "ipAddress")}
        />

        <Select
          isSearchable={false}
          value={{ label: form.comPort, value: form.comPort }}
          label={t("COM_پرت_کارتخوان")}
          className={classes["input"]}
          noOptionsMessage={() => null}
          options={comPorts}
          onChange={(select) => handleChange(select.value, "comPort")}
        />

        <TextField
          type="number"
          numberType="int"
          label={t("پرت_کارتخوان")}
          value={form.posPort}
          error={formErrors.posPort}
          className={classes["input"]}
          onChange={(e) => handleChange(e.target.value, "posPort")}
        />

        <div className={classes["footer"]}>
          <Button
            color="danger"
            onClick={() => setOpenPcPosModal(false)}
            className={clsx(
              classes["yes"],
              isLtr && classes["yes-ltr"]
            )}
          >
            {t("لغو")}
          </Button>

          <Button
            color="success"
            onClick={editMode ? handleEdit : handleSave}
          >
            {t("ذخیره")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SmptPcPosModal